import React, { PropTypes } from 'react';
import { NitroHeading, NitroIcon } from 'nitro-components';

import styled from 'styled-components';

const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  color: ${props => props.theme.color.base3};
  flex-direction: ${props => props.layout === 'vertical' ? 'column' : 'initial'};
  justify-content: ${props => props.layout === 'vertical' ? 'column' : 'initial'};
`;

const Status = props => {
  const {
    variant,
    label,
    layout = 'vertical',
    icon,
    iconSize = '18',
    labelSize = '3',
    noLabel
  } = props;

  const alignment = layout === 'vertical' ? 'center' : 'left';
  // const iconClass = layout === 'horizontal' ? 'icon-push-12' : null;

  const iconRight = layout === 'horizontal' ? 12 : null;
  return (
    <StatusContainer layout={layout}>
      <NitroIcon name={icon} size={iconSize} variant={variant} right={iconRight} />
      {/* <i
        className={
          `icon icon-${icon} icon-size-${iconSize} icon-status-${variant} ${iconClass}`
        }
      /> */}
      {!noLabel &&
        <NitroHeading
          variant={variant}
          size={labelSize}
          label={label}
          noMargin
          align={alignment}
        />}
    </StatusContainer>
  );
};

Status.propTypes = {
  variant: PropTypes.string,
  label: PropTypes.string,
  layout: PropTypes.string,
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  labelSize: PropTypes.string,
  noLabel: PropTypes.bool
};

export default Status;



// WEBPACK FOOTER //
// ./src/components/utils/Status.js